import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  MenuItem,
  Chip,
  Stack,
  Paper,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import InputField from "../../newComponent/themeprovider/textField/InputFiledComp";
import { ThemeProvider } from "@emotion/react";
import mainTheme from "../../newComponent/themeprovider/mainTheme/MainTheme";
import InputSelect from "../../newComponent/themeprovider/textField/InputSelect";
import InputSelectWithTopLable from "../../newComponent/themeprovider/textField/InputSelectWithTopLable";
import { DataGrid } from "@mui/x-data-grid";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomNewButton from "../../newComponent/themeprovider/button/CustomNewButton";
import { getAllTestType } from "../../../services/getAllTestType";
import { getPackagesByTestType } from "../../../services/getPackagesByTestType";
import { createAssignment, EditAssignment } from "./services";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";

const EditAssignmentForm = ({ onClose, rowData }) => {
  const userId = localStorage.getItem("userId");
  const [title, setTitle] = useState(rowData.title || "");
  const [assignmentType, setAssignmentType] = useState(
    rowData.assignment_type || "",
  );
  const [description, setDescription] = useState(rowData.description || "");
  const [maxMarks, setMaxMarks] = useState(rowData.max_marks || 0);
  const [attemptLimit, setAttemptLimit] = useState(rowData.attempt_limit || 0);
  const [selectedFile, setSelectedFile] = useState(rowData?.assignment_object || "");
  const [allowedTypes, setAllowedTypes] = useState([]);
  const [testTypeList, setTestTypeList] = useState([]);
  const [testType, setTestType] = useState(rowData.test_type_id?.id || null);
  const [duration, setDuration] = useState(rowData.package_id?.id || null);
  const [durationList, setDurationList] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [changes, setChanges] = useState({});

  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [saveLoading, setSaveLoading] = useState(false);

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleFieldChange = (fieldName, value) => {
    setChanges((prevChanges) => ({
      ...prevChanges,
      [fieldName]: value,
    }));
    // setValue(fieldName, value); // Update form value
  };

  useEffect(() => {
    const fetchTestType = async () => {
      try {
        const res = await getAllTestType();

        setTestTypeList(res);
      } catch (err) {
        console.error(err);
      }
    };

    fetchTestType();
  }, []);

  useEffect(() => {
    if (!testType) return;

    const fetchDuration = async () => {
      try {
        const res = await getPackagesByTestType(testType);

        setDurationList(res);
      } catch (err) {
        console.error(err);
      }
    };

    fetchDuration();
  }, [testType]);

  // Handle File Upload
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    handleFieldChange("assignment_link", e.target.files[0]);
  };

  // Handle Allowed Types
  const toggleFileType = (type) => {
    if (allowedTypes.includes(type)) {
      setAllowedTypes(allowedTypes.filter((t) => t !== type));
    } else {
      setAllowedTypes([...allowedTypes, type]);
    }
  };

  const handleDeleteFile = () => {
    setSelectedFile(null);
  };

  const handleSubmit = async () => {
    if (Object.keys(changes).length === 0) {
      showSnackbar("No Changes Detected", "warning");
      return;
    }

    setSaveLoading(true);

    try {
      const formData = new FormData();

      // append only changed fields
      Object.entries(changes).forEach(([key, value]) => {
        formData.append(key, value);
      });

      formData.append("user_id", parseInt(userId));
      formData.append("id", parseInt(rowData.id));

      const res = await EditAssignment(formData);

      if (res?.status === 201) {
        showSnackbar("Assignment Updated Successfully");
        setTimeout(() => window.location.reload(), 1200);
      } else {
        showSnackbar(res?.message || "Update Failed", "error");
      }
    } catch (error) {
      showSnackbar("Error Updating Assignment", "error");
      console.error(error);
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <>
      <Backdrop open={saveLoading} style={{ zIndex: 9999 }}>
        <Typography variant="h4" color="error" fontWeight={800} marginRight={2}>
          Saving Data Please wait ...
        </Typography>
        <CircularProgress color="primary" />
      </Backdrop>
      <ThemeProvider theme={mainTheme}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {/* Header */}
            <Typography variant="h6" fontWeight={600} mb={3}>
              Edit Assignment Details
            </Typography>

            <Grid container spacing={3}>
              {/* Assignment Title */}
              <Grid item xs={12}>
                <InputField
                  label="Assignment Title"
                  placeholder="Enter assignment title"
                  textVariant="body2"
                  value={title}
                  onChange={(e) => {
                    setTitle(e.target.value);
                    handleFieldChange("title", e.target.value);
                  }}
                  isRequired
                />
              </Grid>
              <Grid item xs={12}>
                <InputSelectWithTopLable
                  label="Assignment Type"
                  options={[
                    { value: "Reading", label: "Reading" },
                    { value: "Writing", label: "Writing" },
                    { value: "Listening", label: "Listening" },
                  ]}
                  textVariant="body2"
                  value={assignmentType}
                  onChange={(e) => setAssignmentType(e.target.value)}
                  isRequired
                />
              </Grid>
              <InputSelectWithTopLable
                label="Select Test Type"
                options={testTypeList}
                textVariant="body2"
                value={testType}
                onChange={(e) => {
                  setTestType(e.target.value);
                  handleFieldChange("test_type_id", e.target.value);
                }}
                getOptionLabel={(item) => item.name}
                isRequired
              />

              <Grid item xs={12}>
                <InputSelectWithTopLable
                  label="Select Pakckage"
                  value={duration}
                  options={
                    !testType
                      ? [
                          {
                            id: "no-test",
                            package_name: "",
                            label: "Please select test type first",
                            disabled: true,
                          },
                        ]
                      : testType && durationList?.length === 0
                        ? [
                            {
                              id: "no-duration",
                              package_name: "",
                              label:
                                "There is no package available for this test type.",
                              disabled: true,
                            },
                          ]
                        : durationList
                  }
                  getOptionLabel={(item) =>
                    item?.package_name || item?.label || ""
                  }
                  textVariant="body2"
                  onChange={(event) => {
                    setDuration(event.target.value);
                    handleFieldChange("package_id", event.target.value);
                  }}
                  isRequired
                />
              </Grid>

              {/* Description */}
              <Grid item xs={12}>
                {/* <TextField
                fullWidth
                multiline
                rows={3}
                label="Description / Instructions"
                placeholder="Enter instructions"
              /> */}
                <InputField
                  label="Description / Instructions"
                  placeholder="Enter instructions"
                  rows={3}
                  multiline
                  textVariant="body2"
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    handleFieldChange("description", e.target.value);
                  }}
                  isRequired
                />
              </Grid>

              {/* Dates */}
              {/* <Grid item xs={12} md={6}>
              
                  <InputField
                    label="Start Date"
                    type="date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <InputField
                    fullWidth
                    size="small"
                    type="date"
                    label="Due Date"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid> */}

              {/* Marks & Attempts */}
              <Grid item xs={12} md={6}>
                <InputField
                  fullWidth
                  type="number"
                  label="Max Marks"
                  defaultValue={20}
                  size="small"
                  textVariant="body2"
                  value={maxMarks}
                  onChange={(e) => {
                    setMaxMarks(e.target.value);
                    handleFieldChange("max_marks", e.target.value);
                  }}
                  isRequired
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <InputSelectWithTopLable
                  label="Attempt Limit"
                  defaultValue="1"
                  size="small"
                  options={[
                    { value: "1", label: "1" },
                    { value: "2", label: "2" },
                    { value: "3", label: "3" },
                    { value: "Unlimited", label: "Unlimited" },
                  ]}
                  textVariant="body2"
                  value={attemptLimit}
                  onChange={(e) => {
                    setAttemptLimit(e.target.value);
                    handleFieldChange("attempt_limit", e.target.value);
                  }}
                  isRequired
                />
              </Grid>

              {/* Allowed File Types */}
              {/* <Grid item xs={12}>
                  <Typography fontWeight={500} mb={1}>
                    Allowed File Types
                  </Typography>

                  <Stack direction="row" spacing={1}>
                    {fileTypes.map((type) => (
                      <Chip
                        key={type}
                        label={type}
                        clickable
                        color={
                          allowedTypes.includes(type) ? "primary" : "default"
                        }
                        onClick={() => toggleFileType(type)}
                      />
                    ))}
                  </Stack>
                </Grid> */}

              {/* File Upload */}
              <Grid item xs={12}>
                <Typography fontWeight={500} mb={1}>
                  Upload Assignment Document (Max 1)
                </Typography>

                <label htmlFor="upload-file" style={{ width: "100%" }}>
                  <Box
                    sx={{
                      border: "2px dashed #ccc",
                      borderRadius: 2,
                      borderColor: "primary.main",
                      p: 3,
                      textAlign: "center",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#f5f9ff",
                      },
                    }}
                  >
                    <CloudUploadIcon color="primary" sx={{ fontSize: 48 }} />

                    <Typography fontWeight={600}>Click to Upload</Typography>

                    <Typography variant="body2" color="text.secondary">
                      PDF, DOCX, JPG, PNG
                    </Typography>
                  </Box>

                  {/* Hidden Input */}
                  <input
                    id="upload-file"
                    type="file"
                    hidden
                    onChange={handleFileChange}
                    accept=".pdf, .docx, .jpg, .png"
                  />
                </label>

                {selectedFile && (
                  <Paper
                    elevation={1}
                    sx={{
                      mt: 2,
                      p: 1.5,

                      borderRadius: 2,
                    }}
                  >
                    <Typography mb={2} sx={{ textDecoration: "underline" }}>
                      Uploaded Files
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box display="flex" alignItems="center" gap={1}>
                        <InsertDriveFileIcon color="error" />

                        <Typography variant="body2" noWrap>
                          {selectedFile.name || selectedFile?.original_filename}
                        </Typography>
                      </Box>

                      <DeleteIcon
                        color="error"
                        sx={{ cursor: "pointer" }}
                        onClick={handleDeleteFile}
                      />
                    </Box>
                  </Paper>
                )}
              </Grid>

              {/* Class & Students */}
              {/* <Grid item xs={12} md={6}>
                
                  <InputSelectWithTopLable
                    label="Select Class"
                    options={[
                      { value: "Class 10", label: "Class 10" },
                      { value: "Class 11", label: "Class 11" },
                      { value: "Class 12", label: "Class 12" },
                    ]}
                  />
                </Grid> */}

              {/* <Grid item xs={12} md={6}>
                
                  <InputSelectWithTopLable
                    label="Assign To"
                    options={[
                      { value: "All", label: "Whole Batch" },
                      { value: "Selected", label: "Selected Students" },
                    ]}
                  />
                </Grid> */}

              {/* Buttons */}
              <Grid item xs={12}>
                <Stack direction="row" spacing={2} justifyContent="flex-end">
                  <Button variant="outlined" onClick={onClose}>
                    Cancel
                  </Button>

                  <CustomNewButton
                    label="Update Assignment"
                    size="small"
                    onClick={handleSubmit}
                  />
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ThemeProvider>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
};

export default EditAssignmentForm;
